import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { deleteTopic } from "../../../api/api"; // Ensure these functions exist in your api.js
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useTopics } from "../../hooks/useTopicsSimple"; // Ensure this hook exists

const ManageTopics = ({ token, onClose }) => {
  const { topics } = useTopics();

  const handleDelete = async (topicId) => {
    await deleteTopic(token, topicId);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white p-6 w-[400px] max-h-[80vh] overflow-y-auto rounded shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold mb-4 text-center">Manage Topics</h2>
        <ul className="divide-y divide-gray-200">
          {topics.map((topic) => (
            <li
              key={topic.id}
              className="flex justify-between items-center py-2"
            >
              <span className="text-gray-800">{topic.name}</span>
              <button
                onClick={() => handleDelete(topic.id)}
                className="text-red-500 hover:text-red-700"
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </li>
          ))}
        </ul>
        <button
          onClick={onClose}
          className="mt-4 w-full py-2 bg-gray-800 text-white rounded hover:bg-gray-700"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ManageTopics;
